__turbopack_context__.v({
  "category-name": "order-details-module-scss-module__XFXh5a__category-name",
  "category-type": "order-details-module-scss-module__XFXh5a__category-type",
  "container": "order-details-module-scss-module__XFXh5a__container",
  "continue-container": "order-details-module-scss-module__XFXh5a__continue-container",
  "image": "order-details-module-scss-module__XFXh5a__image",
  "image-container": "order-details-module-scss-module__XFXh5a__image-container",
  "image-container-no-selection": "order-details-module-scss-module__XFXh5a__image-container-no-selection",
  "image-loading": "order-details-module-scss-module__XFXh5a__image-loading",
  "image-no-selection": "order-details-module-scss-module__XFXh5a__image-no-selection",
  "image-no-selection-loading": "order-details-module-scss-module__XFXh5a__image-no-selection-loading",
  "include": "order-details-module-scss-module__XFXh5a__include",
  "infos-container": "order-details-module-scss-module__XFXh5a__infos-container",
  "options": "order-details-module-scss-module__XFXh5a__options",
  "options-container": "order-details-module-scss-module__XFXh5a__options-container",
  "plan-includes": "order-details-module-scss-module__XFXh5a__plan-includes",
  "plan-infos": "order-details-module-scss-module__XFXh5a__plan-infos",
  "price": "order-details-module-scss-module__XFXh5a__price",
  "title": "order-details-module-scss-module__XFXh5a__title",
});
